import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  const painPoints = ['Tener que improvisar actividades en el patio', 'Repetir siempre los mismos juegos porque no tenés ideas nuevas', 'Pasar horas buscando actividades que realmente funcionen con tus alumnos', 'Preparar evaluaciones físicas a último momento', 'No tener una planificación clara para todo el año'];
  return <section className="py-20 bg-[#0C2818] relative overflow-hidden" data-id="element-257">
      {/* Subtle red tint background */}
      <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(circle_at_top_right,#F97316_0%,transparent_50%)] opacity-5 pointer-events-none" data-id="element-258"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-260">
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-261">
            Si sos docente de educación física, seguramente esto te resulta
            familiar:
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-262">
          {painPoints.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} className="flex items-start gap-4 bg-[#143524] p-5 rounded-xl border border-orange-900/30 shadow-lg" data-id="element-263">
              <XCircle className="w-6 h-6 text-[#F97316] flex-shrink-0 mt-0.5" data-id="element-264" />
              <span className="text-lg text-gray-300 font-medium" data-id="element-265">{point}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}